import { render, staticRenderFns } from "./row-2.vue?vue&type=template&id=7a20e7ac&scoped=true"
import script from "./row-2.vue?vue&type=script&lang=js"
export * from "./row-2.vue?vue&type=script&lang=js"
import style0 from "./row-2.vue?vue&type=style&index=0&id=7a20e7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a20e7ac",
  null
  
)

export default component.exports